import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {

  properties: any[] = [];
  clientProperties = false;

  rentWiseUserID = '';
  currentProperty: any = null;

  constructor( private http: HttpClient ) { }

  reloadCurrentProperty() {
    if (this.currentProperty) {
      if (this.properties.includes(this.currentProperty)) {
        // already up-to-date
      }
      else {
        this.currentProperty = this.properties.find(p => p._id === this.currentProperty._id);
      }
    }
    else {
      this.currentProperty = null;
    }
  }

  // Get properties from database
  getSelfProperties() {
    return this.http.get('api/v1/properties/self');
  }

  getSelfClientProperties(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/clientProperties/self', { params: queryParams });
  }

  getAllProperties(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/properties/all', { params: queryParams });
  }

  getAllClientProperties(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/clientProperties/all', { params: queryParams });
  }

  getAllPublicProperties(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/public/get-all-properties', { params: queryParams });
  }

  // Add property to a user
  addProperty(data: any) {
    return this.http.post('api/v1/properties/addProperty', data);
  }

  // Add property to a client
  addClientProperty(data: any) {
    return this.http.post('api/v1/clientProperties/addProperty', data);
  }

  // Update one of a user's properties
  updateProperty(propertyID: any, data: any) {
    return this.http.post('api/v1/properties/updateProperty', { ...data, _id: propertyID });
  }

  // Update one of a client's properties
  updateClientProperty(propertyID: any, data: any) {
    return this.http.post('api/v1/clientProperties/updateProperty', { ...data, _id: propertyID });
  }

  deleteProperty(propertyID: any) {
    return this.http.post('api/v1/properties/deleteProperty', { _id: propertyID });
  }

  deleteClientProperty(propertyID: any) {
    return this.http.post('api/v1/clientProperties/deleteProperty', { _id: propertyID });
  }

  deleteClientPropertyFile(propertyID: any, fileID: any) {
    return this.http.post('api/v1/clientProperties/deleteClientPropertyFile', { propertyID, fileID });
  }

  // Register properties uploaded in CSV file
  addManyProperties(collection: any[]) {
    return this.http.post('api/v1/properties/add-many', { properties: collection });
  }

  challengeProperty(propertyID: string, notes: string) {
    return this.http.post('api/v1/properties/challenge-property', { propertyID, notes });
  }

  discardChallenge(propertyID: string) {
    return this.http.post('api/v1/properties/discard-challenge', { propertyID });
  }

  geocodeAddress(address: string, city: string, zipCode: string, buildingNumber?: string) {
    return this.http.post('api/v1/properties/geocode-address', { address, city, zipCode, buildingNumber });
  }

  sendMoveInInspectionForm(propertyID: string, userID: string, data: any) {
    return this.http.post('api/v1/clientProperties/saveMoveInInspectionForm', { propertyID, userID, form: data });
  }

  signClientPropertyFileUpload(propertyID: string, userID: string, filename: string, filesize: number, mimetype: string) {
    return this.http.post<{ fileID: string, presignedUrl: string }>('api/v1/clientProperties/signClientPropertyFileUpload', { propertyID, userID, filename, filesize, mimetype });
  }

  completeClientPropertyFileUpload(propertyID: string, userID: string, fileID: string, uploaded: boolean) {
    return this.http.post('api/v1/clientProperties/completeClientPropertyFileUpload', { propertyID, userID, fileID, uploaded });
  }

}
